module.exports = __webpack_public_path__ + "img/chat.26118f6d.png";